import classes from "./SharePrivacy.module.css";
import { AccessSelector } from "./AccessSelector";
import { ShareInput } from "../ShareInput/ShareInput";

/**
 * The "General access" section: what the link itself grants, and the link.
 *
 * Presentation only — the actions that commit a change live in the dialog
 * footer, beside whichever other action closes it.
 */
export const SharePrivacy = ({ privacy, setPrivacy }) => (
  <div className={classes.generalAccess}>
    <p className={classes.sectionLabel}>General access</p>

    <AccessSelector type={privacy} setType={setPrivacy} />

    {/* Only once the link is what grants access. While the document is
        restricted the link opens for nobody who was not added above, so
        offering it to copy would promise access it does not carry. */}
    {privacy === 0 && <ShareInput />}
  </div>
);
